// react-router v8's `location` exposes `search` (the raw `?a=b` string) but not
// the v3-style parsed `query` object that this app's (largely class-based)
// components were written against. This parses `search` into that object.
//
// Null-safe and shape-tolerant: returns an already-present `query` object if one
// exists (e.g. the loader-built location in routeAuthentication), otherwise
// parses `search`, otherwise `{}`.
export default function locationQuery(location: any): Record<string, string> {
  if (!location) {
    return {};
  }

  if (location.query && typeof location.query === 'object') {
    return location.query;
  }

  return Object.fromEntries(new URLSearchParams(location.search || ''));
}
